import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ListItem } from '@components/ListItem';
import { twJoin } from '@beerntea/pitcher-ui';
import { usePageTransition } from '@/contexts/PageTransitionContext';

gsap.registerPlugin(useGSAP);

interface Props {
  children: React.ReactNode;
  counter: number;
  to: string;
  onMouseEnter: React.MouseEventHandler;
  onMouseLeave: React.MouseEventHandler;
  onClick: React.MouseEventHandler;
}

export function MenuItem({ children, counter, to, onClick, onMouseEnter, onMouseLeave }: Props) {
  const { transitionTo } = usePageTransition();

  return (
    <button
      type="button"
      onClick={(e) => {
        transitionTo(to);
        if (onClick) onClick(e);
      }}
      className="tw-w-full tw-text-start"
    >
      <ListItem
        label={
          <span
            className={twJoin(
              'tw-text-white tw-font-display tw-font-light tw-tracking-[5.12px] tw-flex-1 tw-transition-colors group-hover:tw-text-black',
              'tw-whitespace-nowrap tw-overflow-clip',
              'tw-text-3xl',
              'md:tw-text-[64px] md:tw-leading-[64px]',
            )}
          >
            {children}
          </span>
        }
        subText={
          <span className="tw-text-white tw-font-display tw-text-base tw-tracking-[1.6px] tw-font-light tw-leading-4 tw-transition-colors group-hover:tw-text-black">{`0${counter}`}</span>
        }
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </button>
  );
}
